import React, { useState } from "react";

import CoachPoolContext from "../../../contexts/CoachPoolContext";
import TeamCoachPoolContext from "../../../contexts/TeamCoachPoolContext";

import ChooseCoachPool from "./ChooseCoachPool";
import Coaches from "./Coaches";

export default function Index({ team }) {
  return (
    <TeamCoachPoolContext team={team}>
      <CoachPoolContext>
        <div className="ibox-content">
          <ChooseCoachPool />
          <div className="mt40">
            <Coaches />
          </div>
        </div>
      </CoachPoolContext>
    </TeamCoachPoolContext>
  );
}
